/**
 * Ordem de gravação de campos personalizados.
 *
 * Salvar um campo de aprovação faz o backend criar os slots de aprovação e mover a
 * requisição para "aguardando aprovação". A partir daí o requisitante perde permissão
 * de escrita, e todo campo ainda não gravado passa a ser recusado com 403. Por isso os
 * campos de aprovação precisam ser sempre os últimos a serem enviados.
 */

export const APPROVAL_TRIGGER_FIELD_TYPES = new Set(['approver', 'contract_manager_approver']);

type FieldTypeCarrier = { field_type?: string | null };

export const isApprovalTriggerField = (field: FieldTypeCarrier): boolean =>
  APPROVAL_TRIGGER_FIELD_TYPES.has(String(field?.field_type || '').trim());

/** Mesma lista, com os campos de aprovação deslocados para o fim (ordem relativa preservada). */
export function orderFieldsForSave<T extends FieldTypeCarrier>(fields: T[]): T[] {
  const { regularFields, approvalFields } = partitionFieldsForSave(fields);
  return [...regularFields, ...approvalFields];
}

/** Separa os campos em duas ondas de gravação: primeiro os comuns, depois os de aprovação. */
export function partitionFieldsForSave<T extends FieldTypeCarrier>(
  fields: T[]
): { regularFields: T[]; approvalFields: T[] } {
  const regularFields: T[] = [];
  const approvalFields: T[] = [];
  for (const field of fields) {
    if (isApprovalTriggerField(field)) {
      approvalFields.push(field);
    } else {
      regularFields.push(field);
    }
  }
  return { regularFields, approvalFields };
}
